import isEmpty from 'lodash/isEmpty';

import {delay} from '@edna/utils';

import {showAcceptTariffModal} from './Modals/AcceptTariffModal';
import {showAgreeTariffChangeModal} from './Modals/AgreeTariffChangeModal';
import {tariffsEndpoints} from './api';
import {TTariffChannelType} from './definitions';

export const showAcceptTariff = () => async (dispatch: TDispatch) => {
  const {data: unacceptedTariffs} = await dispatch(
    tariffsEndpoints.getUnacceptedTariffTemplates.initiate(),
  );

  if (unacceptedTariffs?.length) {
    showAcceptTariffModal(unacceptedTariffs);
  }
};

export const showAcceptTariffByChannel =
  (channelType: TTariffChannelType) => async (dispatch: TDispatch) => {
    const {data: unacceptedTariffs} = await dispatch(
      tariffsEndpoints.getUnacceptedTariffTemplates.initiate({channelType}),
    );

    if (unacceptedTariffs?.length) {
      showAcceptTariffModal(unacceptedTariffs);
    }
  };

export const showAgreeTariffChange = () => async (dispatch: TDispatch) => {
  const {data: tariffChangeRequests = []} = await dispatch(
    tariffsEndpoints.getNeedToAgreeTariffChangeRequests.initiate(),
  );

  if (!isEmpty(tariffChangeRequests)) {
    showAgreeTariffChangeModal();

    await delay(300);
  }
};
